import React, { Component } from 'react';
import { Grid, Dialog, DialogTitle, Typography, Button, DialogContent, WithStyles, withStyles } from '@material-ui/core';
import {
    NavigateBeforeOutlined as BackIcon,
} from "@material-ui/icons";
import PerfectScrollbar from 'react-perfect-scrollbar';
import WithContent from '../../../mylibrary/containers/WithContent';
import { addContentStyles } from './addContentStyles';
import { MyPATLocalLoader } from '../../../common';
import { CONTENT_SECTION_KEYS, CONTENT_SECTION_TYPES } from '../../../../constants/comman';

interface AddContentProps extends WithStyles<typeof addContentStyles> {
    openMyLibary: boolean,
    selectedContentType: string;
    handleAddContent?: Function,
    handleBackToComponent?: Function,
    handleContentSelect?: Function,
    isSelectAllRequired?: boolean,
    handleContentSelectAll?: Function,
    selectedQuestionCount: number,
    type: string,
    classes: any,
    preSelectedFilterContent?: object;
    isBonusContent?: boolean;
    bonusCriteria?: any;
    isConcept?: boolean;
    filterContent: any;
    handleInitialState?: Function;
    isCourse?: boolean;
    selectedQuestion?: any;
    onCheckContentExist: Function;
    getAllSelectCount?: Function;
    updateContentTypeValueParent: Function;
    isChapter?:boolean;
}
interface IAddContentStates {
    showLoader: boolean;
}
class AddContent extends Component<AddContentProps, IAddContentStates> {
    constructor(props: AddContentProps) {
        super(props);
        this.state = {
            showLoader: false
        }
    }
    untriggerLoader = () => {
        this.setState({
            showLoader: false,
        });
    }

    updateContentTypeValue = (e: any) => {
        let selectedContentType = e;
        this.props.updateContentTypeValueParent(selectedContentType)
    }

    renderWithContent = () => {
        const { classes, openMyLibary, handleAddContent, selectedQuestionCount, preSelectedFilterContent,
            handleBackToComponent, type, handleContentSelect, handleContentSelectAll, isBonusContent, bonusCriteria, isConcept, filterContent, handleInitialState, isCourse, isSelectAllRequired, selectedQuestion, selectedContentType,isChapter } = this.props;
        const otherDialogProps = {
            fullScreen: true,
        };
        let selectedQuestionsCount = 0;
        return (
                    <Dialog
                        {...otherDialogProps}
                        open={openMyLibary} >

                        {!this.state.showLoader? (<div style={{ width: 'auto' }}>
                            <DialogTitle classes={{ root: classes.dialogTitle }}>
                                <>
                                    <Grid container justify="space-between" alignItems="center">
                                        <Grid item xs="auto">
                                            <Typography
                                                color="textPrimary"
                                                variant="body1"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => { handleBackToComponent && handleBackToComponent(); handleInitialState && handleInitialState(); }}
                                            >
                                                <BackIcon classes={{ root: classes.backIconRoot }} />
                                                <strong>Back </strong>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs />
                                        <Grid item xs="auto">
                                            <Typography variant="caption" inline>
                                                <b style={{ marginRight: '20px', fontSize: 16, }}>{selectedQuestionCount} Selected</b>
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={selectedQuestionCount <= 0}
                                                onClick={() => {
                                                    if (handleAddContent) {
                                                        this.setState({
                                                            showLoader: true,
                                                        }, ()=> {
                                                            setTimeout(() => {
                                                                handleAddContent(isBonusContent, bonusCriteria);
                                                                handleBackToComponent && handleBackToComponent();
                                                                handleInitialState && handleInitialState();
                                                                this.untriggerLoader(); 
                                                            }, 250);
                                                            
                                                        });
                                                        
                                                    }
                                                }}
                                            >
                                                Add Content
                  </Button>
                                        </Grid>
                                    </Grid>
                                </>
                            </DialogTitle>
                            <DialogContent classes={{ root: classes.dialogContent }}>
                                <PerfectScrollbar className={`dialog-content ${classes.perfectScrollbar}`}>
                                    <WithContent
                                        selectedQuestions={selectedQuestion}
                                        selectedContentType={selectedContentType}
                                        isInPopUp={true}
                                        onContentSelect={handleContentSelect}
                                        onContentSelectAll={handleContentSelectAll}
                                        selectedFilterContent={preSelectedFilterContent}
                                        fromTestPaper={true}
                                        removeDisabilityFromCheckBox={true}
                                        isSelectAllRequired={isSelectAllRequired}
                                        contentCreateOption={false}
                                        isConcept={isConcept}
                                        getAllSelectCount={this.props.getAllSelectCount}
                                        // filterSelectedQuestion={filterContent}
                                        isCourse={isCourse}
                                        fromCourseMangement={true}
                                        updateContentType={this.updateContentTypeValue}
                                        isChapter={isChapter}
                                        preSelectedBucket={CONTENT_SECTION_KEYS.GLORIFIRE}
                                    // onCheckContentExist={this.props.onCheckContentExist}
                                    />
                                </PerfectScrollbar>
                            </DialogContent>
                        </div>): (<MyPATLocalLoader/>)}
                    </Dialog>
                )
    }
    render = () => {
        return (
            this.renderWithContent()
        );
    }

}
//@ts-ignore
export default withStyles(addContentStyles)(AddContent);